export default "__VITE_ASSET__CGGtoA4R__"